// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-yaml"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5 13L5 14.0017C5 14.047 4.98745 14.0912 4.96414 14.1278L3.5 16.4286M2 13V14.0017C2 14.047 2.01256 14.0912 2.03586 14.1278L3.5 16.4286M3.5 16.4286V19M7.5 16V13.4286C7.5 13.1919 7.66789 13 7.875 13L10.125 13C10.3321 13 10.5 13.1919 10.5 13.4286V16M7.5 16V19M7.5 16H10.5M10.5 16V19M18.0715 19V13.4286C18.0715 13.1919 17.9116 13 17.7144 13H15.5715M15.5715 13L15.5715 19M15.5715 13H13.0715V19M20.5 13V18.5714C20.5 18.8081 20.6919 19 20.9286 19H21.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4L4 10M4 22H20M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileYamlIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-yaml',
    ref,
    icon: element,
  },
));

FileYamlIcon.displayName = 'FileYamlIcon';

export default FileYamlIcon;
